import React from 'react';
import { ICalendarEventData } from 'src/pages/Calendar/types';
import EventActions from '../EventActions/EventActions';
import './service-request-details.scss';

interface IServiceRequestDetailsProps {
  originalEvent: ICalendarEventData;
  hasValidUrl: () => string | boolean;
  getEventUrl: () => string;
  getViewButtonLabel: () => string;
}

const ServiceRequestDetails = ({
  originalEvent,
  hasValidUrl,
  getEventUrl,
  getViewButtonLabel,
}: IServiceRequestDetailsProps) => (
  <div className="service-request-details">
    <h3>Service Request Details</h3>

    <div className="event-info-grid">
      <div className="event-info-item">
        <div className="event-info-label">Service Request Ticket Number</div>
        <div className="event-info-value ticket-number">
          {originalEvent.ticketNumber}
        </div>
      </div>

      <div className="event-info-item description-item">
        <div className="event-info-label">Description</div>
        <div className="event-info-value">
          {originalEvent.description || originalEvent.name || 'N/A'}
        </div>
      </div>
    </div>

    {hasValidUrl() && (
      <EventActions
        getEventUrl={getEventUrl}
        getViewButtonLabel={getViewButtonLabel}
      />
    )}
  </div>
);

export default ServiceRequestDetails;